import { AnchorHTMLAttributes } from 'react'
import { CONSOLE_LOGIN_LINK } from 'routes/constants'
import { useTrackingContext } from 'routes/components/Layout'
import { Link, LinkType } from 'ui-kit/actions/link/Link'

export default function LoginLink({
  children,
  className,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & {
  type?: LinkType
}) {
  const { addTrackingToUrl } = useTrackingContext()
  return (
    <Link
      href={addTrackingToUrl(CONSOLE_LOGIN_LINK)}
      {...props}
      className={className}
    >
      {children}
    </Link>
  )
}
